import { type SettingsSuccessResponse } from "@/server/api/settings";

export type ServerSettingsState = {
  [K in SettingsSuccessResponse["data"][number] as K["code"]]: K["value"];
};

interface ServerSettingsAction {
  type: "SET_SERVER_SETTINGS";
  payload: ServerSettingsState;
}

const initialState: ServerSettingsState =
  null as unknown as ServerSettingsState;

export const serverSettingsReducer = (
  state: ServerSettingsState = initialState,
  action: ServerSettingsAction
) => {
  switch (action.type) {
    case "SET_SERVER_SETTINGS": {
      return { ...action.payload };
    }
    default:
      return state;
  }
};
